import { supabase } from '../supabase';
import { ALL_MODULES } from './organizationModules';

export const MODULE_ONBOARDING_STATUS_PENDING = 'pending';
export const MODULE_ONBOARDING_STATUS_COMPLETED = 'completed';
export const STARTER_MODULE_ONBOARDING_IDS = [
  'dashboard',
  'ventas-pos',
  'productos',
  'clientes',
  'inventario',
];

const CATEGORY_HINTS = {
  Principal: [
    'Revisa los indicadores mas importantes del dia.',
    'Usa los atajos para entrar rapido a ventas, stock o finanzas.',
    'Toma esta pantalla como tablero de control diario.',
  ],
  Ventas: [
    'Empieza por la accion principal del modulo.',
    'Valida filtros, clientes y medios de cobro antes de operar.',
    'Usa este espacio como circuito diario de atencion.',
  ],
  Inventario: [
    'Aca organizas mercaderia, stock y catalogo.',
    'Primero revisa filtros y categorias para no perder tiempo.',
    'La idea es que el equipo cargue y consulte sin friccion.',
  ],
  Compras: [
    'Centraliza alta, seguimiento y control de compras.',
    'Revisa proveedores y documentos antes de confirmar.',
    'Este modulo acompana el circuito operativo de abastecimiento.',
  ],
  Finanzas: [
    'Controla movimientos, saldos y desvíos del negocio.',
    'Arranca por los indicadores o filtros principales.',
    'Usalo para ver rapido donde tenes que intervenir.',
  ],
  Configuracion: [
    'Aqui defines la base operativa del sistema.',
    'Conviene revisar defaults antes de habilitar al equipo.',
    'Pequenos ajustes aca ahorran trabajo en todas las pantallas.',
  ],
  CRM: [
    'Este modulo ordena el seguimiento comercial y operativo.',
    'Revisa estados, responsables y proximas acciones.',
    'La idea es que el equipo sepa siempre que sigue.',
  ],
  Digital: [
    'Desde aqui controlas la operacion online.',
    'Valida configuraciones y flujo de pedidos antes de publicar.',
    'Es el punto de apoyo para el canal digital.',
  ],
  Produccion: [
    'Este espacio organiza recetas, lotes y produccion.',
    'Empieza por la accion central del modulo para no duplicar tareas.',
    'Pensalo como la base del circuito interno del taller o cocina.',
  ],
  Sistema: [
    'Este modulo agrega soporte extra al equipo.',
    'Conviene recorrer la accion principal primero.',
    'Con una mirada rapida ya vas a saber donde empezar.',
  ],
};

const CUSTOM_MODULE_COPY = {
  dashboard: {
    title: 'Panel de gestion',
    description: 'Aca ves una foto rapida del negocio: ventas, stock, alertas y accesos directos para decidir rapido.',
    bullets: [
      'Mira primero los indicadores principales del dia y del mes.',
      'Usa los atajos para saltar rapido a ventas, stock o rentabilidad.',
      'Tomalo como tu tablero de control diario.',
    ],
    steps: [
      {
        // El selector de sucursal vive en el Topbar (no en el Dashboard): apuntamos
        // al id que realmente existe, dejando el viejo como fallback.
        selector: '[data-onboarding-id="topbar-site-selector"], [data-onboarding-id="dashboard-site-filter"]',
        placement: 'bottom',
        title: 'Tus sucursales',
        description: 'Elegi que local queres mirar o mira el panorama completo.',
        detail: "Si tenes mas de un local, desde aca podes ver como le va a cada uno por separado, o dejarlo en 'Consolidado' para ver la suma de todo.",
      },
      {
        selector: '[data-onboarding-id="dashboard-kpi-ventas"]',
        placement: 'bottom',
        title: 'El pulso de tu dia',
        description: 'Controla de un vistazo cuanta plata va entrando en la caja hoy.',
        detail: 'Tip: Estos numeros son botones. Si haces clic aca, el sistema te lleva directo al listado con el detalle de todos los tickets que cobraste hoy.',
      },
      {
        selector: '[data-onboarding-id="dashboard-sales-trend"]',
        placement: 'right',
        title: 'Tu mes de un vistazo',
        description: 'Mira el ritmo de tu negocio y detecta que dias vendes mas.',
        detail: 'Tip: Pasa el mouse o toca desde el celu cada barrita azul para ver exactamente la plata que facturaste ese dia en particular.',
      },
      {
        selector: '[data-onboarding-id="dashboard-alertas"]',
        placement: 'left',
        title: 'Tu asistente automatico',
        description: 'Te avisamos lo urgente para que no se te pase nada importante.',
        detail: 'Aca te van a saltar alertas solas si te estas quedando sin stock de algun producto, si entran pedidos web o si tenes pagos venciendo hoy.',
      },
      {
        selector: '[data-onboarding-id="dashboard-refresh"]',
        placement: 'left',
        title: 'Datos siempre al dia',
        description: 'Refresca la pantalla para ver tus ultimos movimientos.',
        detail: 'Si acabas de hacer una venta en la caja o cargaste un gasto nuevo, toca este boton para que los numeros de este panel se actualicen al instante.',
      },
    ],
  },
  'ventas-pos': {
    title: 'Punto de venta',
    description: 'Esta es la pantalla de cobro rapido. La idea es que el equipo encuentre productos, cobre y cierre ventas sin friccion.',
    bullets: [
      'Busca productos y arma la venta desde el mostrador.',
      'Confirma cliente, medio de pago y comprobante antes de cobrar.',
      'Usa esta pantalla como flujo principal de atencion.',
    ],
    steps: [
      {
        selector: '[data-onboarding-id="ventas-pos-sale-context"]',
        placement: 'bottom',
        title: 'Datos de la venta',
        description: 'Elegi si es una factura o un presupuesto, y a quien se lo estas vendiendo.',
        detail: "Tip: Por defecto ya viene configurado para 'Consumidor Final', asi no perdes ni un segundo si es una venta rapida de mostrador.",
      },
      {
        selector: '[data-onboarding-id="ventas-pos-search"]',
        placement: 'bottom',
        title: 'Buscador ultrarrapido',
        description: 'Encontra cualquier articulo al instante para que la fila avance rapido.',
        detail: 'Podes tipear el nombre, enchufar un lector de codigos de barras, o tocar el iconito de la derecha para escanear con la camara.',
      },
      {
        selector: '[data-onboarding-id="ventas-pos-catalog"]',
        placement: 'right',
        title: 'Tu catalogo visual',
        description: 'Toca las fotos para ir sumando productos al carrito en un segundo.',
        detail: 'Tip: Usa los botones de arriba para filtrar rapido sin tener que escribir nada. Es ideal si usas tablet o pantalla tactil.',
      },
      {
        selector: '[data-onboarding-id="ventas-pos-checkout"]',
        placement: 'left',
        title: 'Detalle y medio de pago',
        description: 'Aplica descuentos, cobra recargos y defini como te paga el cliente.',
        detail: 'Aca eliges si te pagan en efectivo, con tarjeta o transferencia. El total se actualiza solo al instante.',
      },
      {
        selector: '[data-onboarding-id="ventas-pos-submit"]',
        placement: 'top',
        title: 'A cobrar',
        description: 'El paso mas lindo: cierra la venta y guarda la plata en la caja.',
        detail: 'Al tocar este boton, la plata entra a tu caja diaria y el stock se descuenta automaticamente. Todo listo para el proximo cliente.',
      },
    ],
  },
  caja: {
    title: 'Arqueo de Caja',
    description: 'Este es el corazon del control de efectivo. Aca declaras tus saldos, registras salidas de plata y controlas que te cierren los numeros.',
    bullets: [
      'Abre un turno para empezar a cobrar ventas.',
      'Suma ingresos o gastos manuales con un clic.',
      'Revisa tu teoria vs realidad antes de cerrar el dia.',
    ],
    steps: [
      {
        selector: '[data-onboarding-id="caja-actions"]',
        placement: 'bottom',
        title: 'Acciones de turno',
        description: 'Tus controles principales.',
        detail: 'Desde aca habilitas la caja para tu turno, agregas gastos como "Pago a fletero" y, al finalizar tu horario, cerras la caja para rendir el dinero.',
      },
      {
        selector: '[data-onboarding-id="caja-kpis"]',
        placement: 'bottom',
        title: 'Panel de saldos',
        description: 'No calcules nada a mano, nosotros cruzamos la data.',
        detail: 'Con cada venta del local o gasto registrado, el "Saldo Teorico" se calcula solo. Cuando cuentes tus billetes, ese valor es tu objetivo.',
      },
      {
        selector: '[data-onboarding-id="caja-tabs"]',
        placement: 'right',
        title: 'Filtros y Pestañas',
        description: 'Audita el ahora o el pasado.',
        detail: 'Podes alternar facilmente entre los tickets de tu turno abierto actual, o entrar a la seccion de historial para ver que paso en turnos viejos de otros empleados.',
      },
      {
        selector: '[data-onboarding-id="caja-list"]',
        placement: 'top',
        title: 'Ticketera de movimientos',
        description: 'Tu lista sabana de operaciones.',
        detail: 'Toda venta que entre por cobro o cualquier gasto que saques figurara listado aca abajo. Si te equivocas en algo manual, podes anularlo tocando la fila.',
      },
    ],
  },
  clientes: {
    title: 'Gestion de clientes',
    description: 'Desde esta pantalla ordenas la base comercial y accedes rapido a historial, movimientos y datos de contacto.',
    bullets: [
      'Empieza por el buscador para encontrar clientes rapido.',
      'Usa la ficha para revisar saldo, compras o datos clave.',
      'Centraliza aqui la atencion comercial del dia a dia.',
    ],
  },
  inventario: {
    title: 'Stock actual',
    description: 'Este modulo te ayuda a revisar existencias, detectar faltantes y ordenar el stock operativo de la empresa.',
    bullets: [
      'Filtra por sucursal o categoria para enfocarte rapido.',
      'Usa esta vista como referencia antes de vender o comprar.',
      'Te sirve para detectar quiebres y movimientos pendientes.',
    ],
  },
};

// Mismo criterio que MODULE_ONBOARDING_DEFINITIONS: los permisos finos no
// tienen pantalla, asi que tampoco deben resolver una definicion de onboarding.
const ONBOARDABLE_MODULES = ALL_MODULES.filter((module) => !module.permissionOnly);

const MODULE_LOOKUP = new Map(ONBOARDABLE_MODULES.map((module) => [module.id, module]));

const buildModuleDefinition = (module) => {
  const customCopy = CUSTOM_MODULE_COPY[module.id];
  if (customCopy) {
    return {
      ...module,
      ...customCopy,
    };
  }

  return {
    ...module,
    title: module.label,
    description: `Te mostramos rapido como arrancar con ${module.label.toLowerCase()} para que el equipo no entre a ciegas.`,
    bullets: CATEGORY_HINTS[module.category] || CATEGORY_HINTS.Configuracion,
  };
};

// Los permisos finos (`permissionOnly`) no tienen pantalla propia, asi que no
// hay onboarding que mostrar ni estado que resetear para ellos.
export const MODULE_ONBOARDING_DEFINITIONS = ONBOARDABLE_MODULES.map(buildModuleDefinition);

export function normalizeModuleOnboardingStatuses(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {};

  return Object.entries(value).reduce((acc, [moduleId, status]) => {
    const normalizedStatus = String(status || '').toLowerCase();
    acc[moduleId] =
      normalizedStatus === MODULE_ONBOARDING_STATUS_PENDING
        ? MODULE_ONBOARDING_STATUS_PENDING
        : MODULE_ONBOARDING_STATUS_COMPLETED;
    return acc;
  }, {});
}

export function getModuleOnboardingStatus(statuses, moduleId) {
  const normalized = normalizeModuleOnboardingStatuses(statuses);
  return normalized[moduleId] === MODULE_ONBOARDING_STATUS_PENDING
    ? MODULE_ONBOARDING_STATUS_PENDING
    : MODULE_ONBOARDING_STATUS_COMPLETED;
}

export function buildModuleOnboardingStatuses(moduleIds = [], status = MODULE_ONBOARDING_STATUS_PENDING) {
  return [...new Set(moduleIds)].reduce((acc, moduleId) => {
    acc[moduleId] =
      status === MODULE_ONBOARDING_STATUS_PENDING
        ? MODULE_ONBOARDING_STATUS_PENDING
        : MODULE_ONBOARDING_STATUS_COMPLETED;
    return acc;
  }, {});
}

export function buildStarterModuleOnboardingStatuses(enabledModules = []) {
  const enabledSet = Array.isArray(enabledModules) && enabledModules.length > 0
    ? new Set(enabledModules)
    : null;

  const moduleIds = STARTER_MODULE_ONBOARDING_IDS.filter((moduleId) => {
    if (!MODULE_LOOKUP.has(moduleId)) return false;
    return enabledSet ? enabledSet.has(moduleId) : true;
  });

  return buildModuleOnboardingStatuses(moduleIds, MODULE_ONBOARDING_STATUS_PENDING);
}

export function shouldShowModuleOnboarding(statuses, moduleId) {
  if (!moduleId) return false;
  return (
    getModuleOnboardingStatus(statuses, moduleId) === MODULE_ONBOARDING_STATUS_PENDING &&
    MODULE_LOOKUP.has(moduleId)
  );
}

export function getModuleOnboardingDefinition(moduleId) {
  const module = MODULE_LOOKUP.get(moduleId);
  if (!module) return null;
  return buildModuleDefinition(module);
}

export async function updateModuleOnboardingStatuses({
  organizationId,
  moduleOnboardingStatuses,
}) {
  if (!organizationId) {
    throw new Error('Falta organizationId para guardar el onboarding por modulo.');
  }

  const normalizedStatuses = normalizeModuleOnboardingStatuses(moduleOnboardingStatuses);

  const { error } = await supabase
    .from('organizations')
    .update({ module_onboarding_statuses: normalizedStatuses })
    .eq('id', organizationId);

  if (error) throw error;

  return normalizedStatuses;
}

export async function completeModuleOnboardingStep({
  organizationId,
  moduleId,
  currentStatuses,
}) {
  const nextStatuses = {
    ...normalizeModuleOnboardingStatuses(currentStatuses),
    [moduleId]: MODULE_ONBOARDING_STATUS_COMPLETED,
  };

  await updateModuleOnboardingStatuses({
    organizationId,
    moduleOnboardingStatuses: nextStatuses,
  });

  return nextStatuses;
}
